import { useContext } from 'react';
import StockPriceTable from './table';
import { StockPriceContext } from './context';

const ExtensionPlants = () => {
  const { plants, setPlants } = useContext(StockPriceContext);

  const handleStandardPriceChange = (plantCode, value) => {
    setPlants((prev) =>
      prev.map((item) =>
        item.plant === plantCode ? { ...item, standard_price: value === null ? '' : value } : item,
      ),
    );
  };

  return (
    <StockPriceTable
      plants={plants}
      loading={false}
      handleStandardPriceChange={handleStandardPriceChange}
    />
  );
};

export default ExtensionPlants;
